import React from 'react';
import PropTypes from 'prop-types';

import MuiContainer from '@mui/material/Container';
import { sxPropType } from '../../proptypes/misc';

function Container({ sx, narrow, ...other }) {
  return (
    <MuiContainer
      // maxWidth has to be disabled here, otherwise it overwrites the maxWidth below with the width of the lg breakpoint
      maxWidth={false}
      sx={[
        (theme) => ({
          paddingLeft: '24px',
          paddingRight: '24px',
          maxWidth: '1560px',
          [theme.breakpoints.up('md')]: {
            paddingLeft: '150px',
            paddingRight: '150px',
          },
        }),
        narrow &&
          ((theme) => ({
            [theme.breakpoints.up('md')]: {
              maxWidth: '765px',
              paddingLeft: '0',
              paddingRight: '0',
            },
          })),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    />
  );
}

Container.propTypes = {
  sx: sxPropType,
  narrow: PropTypes.bool,
};

Container.defaultProps = {
  sx: [],
  narrow: false,
};

export default Container;
